// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"36d8c10e","232":"36d8c10e","299":"36d8c10e","573":"36d8c10e","829":"36d8c10e"}[chunkId] + ".chunk.css";
};